import { Reducer } from 'redux'
import {
  StorefrontActionTypes,
  type StorefrontAction,
  type StorefrontState,
  initialStorefrontState,
} from './types'

export * from './types'

export const reducer: Reducer<StorefrontState, StorefrontAction> = (
  state = initialStorefrontState,
  action
) => {
  switch (action.type) {
    case StorefrontActionTypes.SET_TEMPLATES_DATA: {
      return { ...state, templates: action.payload }
    }
    case StorefrontActionTypes.SET_INTEGRATIONS_DATA: {
      return { ...state, integrations: action.payload }
    }
    case StorefrontActionTypes.CLEAR_INTEGRATIONS_DATA: {
      return { ...state, integrations: [] }
    }

    default: {
      return state
    }
  }
}
